<template>
  <v-btn
    v-tooltip="tooltip"
    :color="color"
  >
    <v-icon :icon="icon" />
  </v-btn>
</template>

<script setup lang="ts">
defineProps<{
  tooltip: string;
  color: string;
  icon: string;
}>();
</script>
